/* 
  This is contributor dynamic route. Used in catalog site like
  https://openroadmedia.com/contributor/octavia-e-butler

  Both authorpage and contirbutorpage needs to call single component
*/
"use client";
import React from "react";
import { useAppContext } from "@components/Provider";
import Meta from "src/components/Meta";
import Entity from "src/components/Entity";
import {
  appendHttpsToUrl,
  RenderPersonSchema,
  decodeHtmlEntities,
} from "src/helpers/Helper";
import AuthorRoles from "src/constants/AuthorRoles";
import styles from "./contributor.module.css";
import { useSearchParams } from "next/navigation";
import NextImage from "@components/Image/NextImage";
import FollowButton from "@components/FollowButton/FollowButton";
import CatalogBookCard from "@components/CatalogBookCard/CatalogBookCard";
import RelatedPostCard from "@components/RelatedPostCard/RelatedPostCard";

const Contributor = (props) => {
  const { data } = useAppContext() || {};
  const { siteId = "", host = "" } = props || {};
  const params = useSearchParams();
  const isMD = params?.get("md"); // Getting the md parameter to check if user is coming from Author's site

  let ContributorArray = Array.isArray(props?.data) ? props?.data : [];
  let [Contributor] = ContributorArray,
    // let [Contributor] = (props && props?.data) || [],
    {
      books = [],
      contributor = [],
      related_posts = [],
    } = (Contributor && Contributor.ContributorDetail) || {},
    { SiteSettings = {} } = data || {},
    siteName = SiteSettings?.site_name || "",
    displayName = decodeHtmlEntities(contributor?.[0]?.display_name) || "",
    authorId = contributor?.[0]?.firebrand_id || "",
    contibutorImage = contributor?.[0]?.image || "",
    shortBio = contributor?.[0]?.short_bio || "";

  contibutorImage = appendHttpsToUrl(contibutorImage || "");

  let primaryAuthorBooks = books?.map((item) => {
    let primaryAuthors = item?.authors?.filter(
      (x) =>
        (x?.role || x?.Role) === AuthorRoles.PRIMARY &&
        x?.firebrand_id === parseInt(authorId)
    );
    if (primaryAuthors?.length > 0) return item;
  });

  primaryAuthorBooks = primaryAuthorBooks?.filter((x) => x !== undefined);

  const totalBooks = primaryAuthorBooks?.length || 0;

  return (
    <React.Fragment>
      <Meta
        displayName={`${displayName} | ${siteName}`}
        shortBio={shortBio}
        url={props?.pageUrl || ""}
        pageType={Entity.CONTRIBUTOR}
        siteName={siteName}
        Image={contibutorImage}
        isNewAppRouter={true}
      />
      <div
        className={
          props?.isMobile ? `bookCardContainer topPadding` : `bookCardContainer`
        }
      >
        <div className={styles.contributorSection}>
          <div className={styles.contibutorImage}>
            <NextImage
              ImageUrl={
                contibutorImage
                  ? contibutorImage
                  : "https://book-assets.openroadmedia.com/defaultprofileimage.jpg"
              }
              Title={displayName}
              Alt_Text={displayName}
              width={300}
              height={300}
              isLazyload={false}
            />
          </div>
          <div
            className={styles.contributorDetail}
            id={props?.isMobile ? `center` : "ctr"}
          >
            <h1 className={styles.contibutorHeading}>
              {displayName}
              <FollowButton
                eventName="clickFollow-AuthorPage"
                titleISBN=""
                author={displayName}
                authorId={authorId}
                siteId={siteId}
                classes="authorIconTop"
                isLazyLoad={false}
                isMD={isMD}
              />
            </h1>
            <div
              className={styles.contibutorDesc}
              dangerouslySetInnerHTML={{ __html: shortBio }}
            />
          </div>
        </div>

        <div className="bookCardContainer">
          <h2 className={styles.bookCount}>
            Books By {displayName} (
            {totalBooks > 1 ? `${totalBooks} Books` : `${totalBooks} Book`})
          </h2>
          <div className="booksCard">
            <CatalogBookCard
              Books={primaryAuthorBooks}
              AffiliateCode={SiteSettings?.preview_link_affiliate_code || ""}
              SiteId={siteId}
              host={host}
              ShowContributor={false}
              TotalBooks={totalBooks}
              RenderSchema={true}
              ShowFollowAuthor={true}
              EventName="clickFollow-AuthorPage"
              ShouldLazyLoadCount={4}
              subscriberCookie={props?.subscriberCookie || ""}
            />
          </div>
        </div>
        {related_posts && related_posts.length > 0 ? (
          <div className={styles.relatedPostSection}>
            <hr />
            <h3 className={styles.center}>
              RELATED POSTS ABOUT {displayName.toUpperCase()}
            </h3>
            <div className={styles.relatedPost}>
              <RelatedPostCard RelatedPosts={related_posts} />
            </div>
          </div>
        ) : (
          ""
        )}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={RenderPersonSchema(
            displayName,
            contibutorImage,
            props?.pageUrl || "",
            shortBio
          )}
        />
      </div>
    </React.Fragment>
  );
};

export default Contributor;
